import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { TokenService } from '../services/token.service';
import { API_CONFIG } from '../config/api.config';

/**
 * Functional HTTP interceptor that:
 * 1. Attaches the Bearer token to outgoing API requests.
 * 2. On 401 responses, triggers logout.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const authService = inject(AuthService);

  // Skip the token endpoint itself — it uses client credentials, not Bearer
  if (req.url.includes('/oauth2/token')) {
    return next(req);
  }

  const token = tokenService.getAccessToken();

  const authReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq).pipe(
    catchError((error) => {
      if (error.status === 401) {
        authService.logout();
      }
      return throwError(() => error);
    }),
  );
};
